import newProduct from "./newProductSchema";

export const productSchemas = {
  newProduct
};
